import React from 'react'
import unicornBg from '../images/unicorn.jpg'

const Unicorn = () =>
  <div>
    <img className='unicorn-bg-image' src={unicornBg} />
  </div>

export default Unicorn



// WEBPACK FOOTER //
// ./src/components/Unicorn.js